import React from 'react';
import { BsBriefcaseFill } from 'react-icons/bs';
import { HiBriefcase, HiCurrencyRupee, HiLocationMarker } from 'react-icons/hi';
import { TiLocation } from 'react-icons/ti';
import { Img } from 'react-image';
import { WorkingMode } from 'types';

interface OpportunitiesCardDetailProps {
	workingMode: string;
	minSalary: string;
	maxSalary: string;
	internshipSalary?: { min: number; max: number };
	internshipDuration?: number;
	location: string;
	type: string;
}

const formatWorkingMode = (workingMode: string): string => {
	switch (workingMode) {
		case WorkingMode.FULL_TIME:
			return 'Full-Time';
		case WorkingMode.INTERNSHIP:
			return 'Internship';
		case WorkingMode.INTERNSHIP_TO_FULL_TIME:
			return 'Internship + Full-Time';
		default:
			return workingMode;
	}
};

const OpportunitiesCardDetail: React.FC<OpportunitiesCardDetailProps> = ({
	workingMode,
	minSalary,
	maxSalary,
	internshipSalary,
	internshipDuration,
	location,
	type,
}) => {
	const isInternship = workingMode === WorkingMode.INTERNSHIP || workingMode === WorkingMode.INTERNSHIP_TO_FULL_TIME;
	const showInternshipSalary = isInternship && internshipSalary && internshipSalary.min > 0;
	const showFullTimeSalary =
		(workingMode === WorkingMode.FULL_TIME || workingMode === WorkingMode.INTERNSHIP_TO_FULL_TIME) &&
		minSalary !== '0' && maxSalary !== '0' && minSalary !== '' && maxSalary !== '';

	return (
		<div className="mt-[8px]">
			<div className="mt-2 flex flex-wrap gap-4">
				<div className="flex items-center text-sm font-medium dark:text-[#FAFAFC] text-black">
					<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
					<div className="ml-1 gap-1 flex">
						{formatWorkingMode(workingMode)}
						{internshipDuration && internshipDuration > 0 && (
							<>
								<span className="mx-1 inline-block h-2 align-middle">
									<Img src="/assets/dot.svg" alt="dot" width={6} height={6} />
								</span>
								<span>{internshipDuration} {internshipDuration === 1 ? 'Month' : 'Months'}</span>
							</>
						)}
					</div>
				</div>

				{showInternshipSalary && (
					<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
						<span className="mr-1 inline-block align-middle">
							<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
						</span>
						Internship: {internshipSalary.min}K - {internshipSalary.max}K/month
					</div>
				)}

				{showFullTimeSalary && (
					<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
						<span className="mr-1 inline-block align-middle">
							<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
						</span>
						{minSalary} - {maxSalary} LPA
					</div>
				)}

				<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
					<span className="mr-1 inline-block align-middle">
						<HiLocationMarker className="text-[#00B7C4] dark:text-[#A9EFF2] w-[16px] h-[16px]" />
					</span>
					{location}
					<span className="mx-1 inline-block h-2 align-middle">
						<Img src="/assets/dot.svg" alt="dot" width={6} height={6} />
					</span>
					{type}
				</div>
			</div>
		</div>
	);
};

export default OpportunitiesCardDetail;
